import clsx from "clsx";
import { forwardRef } from "react";

import { BUTTON_CLASS_NAME, BUTTON_TEXT_CLASS_NAME } from "./const";
import { LoadingWrapper } from "./LoadingWrapper";
import { ButtonProps } from "./type";

/**
 * - 基本的には横幅サイズ可変ですが、必要に応じでコンテンツに対し100%のサイズで配置します。
 * - 高さはどんな場合でも固定です。
 * - FillボタンとOutlineボタンの並列配置は想定しています。
 *
 *  ※原則として、同一画面にRight IconボタンとLeft Iconボタンは混在しない・させない。
 * ※コントラスト設計の関係からアイコンカラーとテキストカラーが異なる箇所が存在します。
 */
export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      size = "md",
      styleType = "fill",
      disabled,
      isLoading = false,
      icon,
      iconType,
      hasWhiteBorder = false,
      children,
      block,
      danger,
      transparent = false,
      warn = false,
      dataAttributes,
      ...props
    },
    ref,
  ) => (
    <div className={clsx("relative w-fit", { "w-full": block })}>
      <button
        ref={ref}
        disabled={disabled || isLoading}
        className={BUTTON_CLASS_NAME({
          size,
          styleType,
          iconType: icon ? iconType : undefined,
          hasWhiteBorder,
          block,
          danger,
          transparent,
          warn,
        })}
        {...dataAttributes}
        {...props}
      >
        {icon && iconType === "left" && <span>{icon}</span>}
        {iconType === "only" ? (
          <span className={clsx(isLoading && "opacity-0")}>{icon}</span>
        ) : (
          <span className={BUTTON_TEXT_CLASS_NAME({ size })}>{children}</span>
        )}
        {icon && iconType === "right" && <span>{icon}</span>}
      </button>
      {isLoading && <LoadingWrapper size={size} styleType={styleType} />}
    </div>
  ),
);

Button.displayName = "Button";
